// Libs
import React from 'react';

// Components
import DeviceView from './DeviceView';
import DesktopView from './DesktopView';

// Hooks
import useGridContent from './useGridContent';

const GridContent = ({
  product,
  order,
  orderItem,
  isRecurring = false,
  addressesCount = 1,
}) => {
  const { isMobileMode, isTabletMode, ...gridContentProps } = useGridContent({
    product,
    order,
    orderItem,
    isRecurring,
    addressesCount,
  });

  const viewProps = {
    product,
    order,
    orderItem,
    isRecurring,
    addressesCount,
    isMobileMode,
    isTabletMode,
    ...gridContentProps,
  };

  return isMobileMode || isTabletMode ? (
    <DeviceView {...viewProps} />
  ) : (
    <DesktopView {...viewProps} />
  );
};

export default GridContent;
